import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { setDioHovered } from '../clergy-comp-report-slice';
import { domesticMapSelection, handleDioClick, handleRegionClick, provHover } from '../map-actions';



export function DomesticMap() {

	const dispatch = useDispatch();
	useEffect(() => {
		return function cleanUp() {
			domesticMapSelection.currentRegion = null;
			domesticMapSelection.currentDio = null;
		};
	}, []);
	return (
		<ReactSVG
			src='/static/img/clergy-comp/domestic.svg'
			beforeInjection={(svg) => {
				const regions: ChildNode[] = [];
				svg.childNodes.forEach(a => {
					if (a.nodeName === 'g') regions.push(a);
				});
				regions.forEach(region => {
					region.addEventListener('click', () => handleRegionClick(region as HTMLElement, regions as HTMLElement[], svg, dispatch));
					region.addEventListener('mouseover', () => {
						if (domesticMapSelection.currentRegion !== (region as HTMLElement).getAttribute('prov'))
							provHover('0.7', region as HTMLElement);
					});
					region.addEventListener('mouseout', () => provHover('1', region as HTMLElement));
					region.childNodes.forEach((dio) => {
						if (dio.nodeName === 'g') {
							dio.addEventListener('click', () => handleDioClick(dio as HTMLElement, region as HTMLElement, dispatch));
							dio.addEventListener('mouseover', () => {
								dispatch(setDioHovered(replaceAll((dio as HTMLElement)?.getAttribute('id').replace('Dio_', ''), '_', ' ')));
								if (domesticMapSelection.currentRegion === (region as HTMLElement).getAttribute('prov'))
									provHover('0.7', dio as HTMLElement);
							});
							dio.addEventListener('mouseout', () => {
								provHover('1', dio as HTMLElement);
								dispatch(setDioHovered(''));
							});
						}
					});
				});
			}}
		/>
	);
}